module.exports = __webpack_public_path__ + "static/media/icon-collection.6db974db.svg";